module.exports = __webpack_public_path__ + "static/media/info.7b9be93f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/play-screen-icons/info.svg
// module id = 451
// module chunks = 0